// import { EmptyNetImpactLensBox } from '@upright/ui/common/upright/core/impact-lenses/net-impact/empty-state';
import { ModelEntityType } from '@upright/common/model/input/types';
import { SingleImpactInfoBox } from '@upright/ui/common/upright/core/impact-lenses/net-impact/info-boxes/single-impact';
import { SingleImpactInfoBoxConnector } from '@upright/ui/common/upright/core/impact-lenses/net-impact/info-boxes/single-impact/single-impact-info-box-connector';
import { useNetImpactLensContext } from '../common/use-net-impact-lens-context';
import { KeyTakeawayConnectors, KeyTakeawayInfoBoxes } from './key-takeaways';

export function NetImpactInfoBoxes() {
  const context = useNetImpactLensContext();
  return (
    <>
      {shouldShowKeyTakeawayBoxes(context) ? <KeyTakeawayInfoBoxes /> : <></>}
      <SingleImpactInfoBox />
    </>
  );
}

export function NetImpactInfoBoxConnectors() {
  const context = useNetImpactLensContext();
  return (
    <>
      {shouldShowKeyTakeawayBoxes(context) ? <KeyTakeawayConnectors /> : <></>}
      <SingleImpactInfoBoxConnector />
    </>
  );
}

function shouldShowKeyTakeawayBoxes(context: ReturnType<typeof useNetImpactLensContext>) {
  const data = context?.data;
  const entityType = data?.entity?.type;
  const selection = context?.state;
  const hasSelection = selection?.valence && selection.impact;
  const shouldAlwaysHide = !!context?.state.hideKeyTakeawayBoxes;

  if (shouldAlwaysHide) return false;
  if (hasSelection) return false;
  if (!entityType) return false;
  if (!entityTypesWithKeyTakeawaysBoxes.includes(entityType)) return false;

  return true;
}

const entityTypesWithKeyTakeawaysBoxes = [ModelEntityType.COMPANY, ModelEntityType.GROUP, ModelEntityType.PORTFOLIO];
